import { render, staticRenderFns } from "./personOpen.vue?vue&type=template&id=7c562b85&scoped=true&"
import script from "./personOpen.vue?vue&type=script&lang=js&"
export * from "./personOpen.vue?vue&type=script&lang=js&"
import style0 from "./personOpen.vue?vue&type=style&index=0&id=7c562b85&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c562b85",
  null
  
)

export default component.exports